import { Col, Collapse, Row, Spin, Typography } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isNull } from "lodash";
import { getInventoryAlertSummary } from "../../../store/dashboard/dashboardActions";
import InventoryAlertTable from "./InventoryAlertTable";

const { Text } = Typography;

const InventoryAlertCollapse = () => {
  const dispatch = useDispatch();

  const brokerId = useSelector((state) => state.actor.details.data.BrokerId);
  const { data, loading, fetched } = useSelector(
    (state) => state.dashboard.inventoryAlertSummary
  );

  useEffect(() => {
    if (!isNull(brokerId)) {
      dispatch(getInventoryAlertSummary(brokerId));
    }
  }, [brokerId]);

  const belowThresholdCount = Array.isArray(data) ? data.length : 0;

  // Hide panel if not loading and no alerts
  if (!fetched || (!loading && belowThresholdCount === 0)) {
    return null;
  }

  const panelHeader = (
    <Row>
      <Col xs={24} sm={24} md={24} lg={10} xl={10} xxl={10}>
        <Typography>
          <Text strong>Inventory Alert</Text>
        </Typography>
      </Col>
      <Col xs={24} sm={24} md={24} lg={10} xl={10} xxl={10}>
        <Text>
          Plate types below threshold:{" "}
          {loading ? (
            <Spin size="small" />
          ) : (
            <Text strong>{belowThresholdCount.toLocaleString()}</Text>
          )}
        </Text>
      </Col>
    </Row>
  );

  const items = [
    {
      children: (
        <Row>
          <Col span={24}>
            <InventoryAlertTable data={data} loading={loading} />
          </Col>
        </Row>
      ),
      key: "1",
      label: panelHeader,
      size: "small",
      showArrow: true,
    },
  ];

  return (
    <div>
      <Collapse items={items} />
    </div>
  );
};

export default InventoryAlertCollapse;
